export default "__VITE_ASSET__DDDkZFGh__"